const Answer = (props)=>{
    return(
        <div className="answer_body">
            <p className="answer_text">{props.content}</p>
        </div>
    )
}

export default Answer;